import { render, staticRenderFns } from "./TrimesterSelector.vue?vue&type=template&id=3152fbb1&"
import script from "./TrimesterSelector.vue?vue&type=script&lang=js&"
export * from "./TrimesterSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports